export default "__VITE_ASSET__BEDhFn6i__"